// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/admin";

let impersonationRoute = baseRoute + "/impersonation";

let shopsRoute = baseRoute + "/shops";

export {
  baseRoute,
  impersonationRoute,
  shopsRoute,
}
/* No side effect */
